export default function deepClone(value) {
    if (typeof window !== "undefined" && typeof window.structuredClone === "function") {
        return window.structuredClone(value);
    }

    if (value === null || value === undefined || typeof value !== "object") {
        return value;
    }

    if (value instanceof Date) {
        return new Date(value.getTime());
    }

    if (Array.isArray(value)) {
        return value.map((item) => deepClone(item));
    }

    const clone = {};

    Object.keys(value).forEach((key) => {
        clone[key] = deepClone(value[key]);
    });

    return clone;
}